module.exports = __webpack_public_path__ + "static/media/fvs_valve1_49.6db7087b.jpg";